import { render, staticRenderFns } from "./feeDetailsNew.vue?vue&type=template&id=64620b92&scoped=true&"
import script from "./feeDetailsNew.vue?vue&type=script&lang=js&"
export * from "./feeDetailsNew.vue?vue&type=script&lang=js&"
import style0 from "./feeDetailsNew.vue?vue&type=style&index=0&id=64620b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64620b92",
  null
  
)

export default component.exports